import {t} from '@lingui/macro'
import {Helmet} from 'react-helmet'
import {Navigate} from 'react-router'
import {useLocation} from 'react-router-dom'

import {useUser} from '@product-web/user'

import {LoginFlow} from './login-flow'

function Login() {
    const user = useUser()
    const location = useLocation()
    const redirect = location.state?.redirect ?? '/'

    if (user) {
        return <Navigate to={redirect} />
    }
    return (
        <>
            <Helmet>
                <title>{t`Log in`}</title>
            </Helmet>
            <LoginFlow />
        </>
    )
}
export default Login
